import { createI18n } from 'vue-i18n'
import it from './locales/it.json'
import en from './locales/en.json'
import es from './locales/es.json'

const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem('user-language') || 'it',
    fallbackLocale: 'en',
    messages: {
        it,
        en,
        es
    }
})

export default i18n
